import { useAuth } from "features/store";
import { User } from "features/auth/auth";

/** Grants the Settings page and every write on /feature-flags/. */
export const MANAGE_FEATURE_FLAGS_PERMISSION = "core.manage_feature_flags";

/**
 * Whether the signed-in user holds a Django permission. False until the user
 * has loaded, so a caller that must tell "not yet known" from "denied" checks
 * `useAuth().user` itself.
 */
export const useHasPermission = (permission: string): boolean => {
  // AuthState.user is still `any`; typing it at the slice ripples into
  // consumers outside this feature, so the shape is stated here instead.
  const user: User | null | undefined = useAuth().user;
  return user?.permissions?.includes(permission) ?? false;
};
